module.exports = __webpack_public_path__ + "static/media/synthetic drugs.ccd2f998.svg";